import { render, staticRenderFns } from "./DriverStatusCard.vue?vue&type=template&id=310856bf&scoped=true&"
import script from "./DriverStatusCard.vue?vue&type=script&lang=js&"
export * from "./DriverStatusCard.vue?vue&type=script&lang=js&"
import style0 from "./DriverStatusCard.vue?vue&type=style&index=0&id=310856bf&lang=sass&scoped=true&"
import style1 from "./DriverStatusCard.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310856bf",
  null
  
)

export default component.exports